import React from "react";

import BannerImages from "../../../Common/BannerImages";
import { templateDefaultValue } from "@constants/template";
import LanguageTable from "../../../Common/LanguageTable";

export function LoyaltySection() {
    const imagePath = React.useMemo(
        () => ["Application", "LaindingPage", "Default", "Loyalty", "Bannier"],
        []
    );

    return (
        <div className="banner-container">
            <section className="text-section">
                <div className="banner-images">
                    <BannerImages
                        dataPath={imagePath}
                        title="Advertising Banner"
                        size="(png,jpg,jpeg ou webp)"
                    />
                </div>

                <LanguageTable
                    path={["Application", "LaindingPage", "Default", "Loyalty"]}
                    fields={[
                        {
                            key: "Title1",
                            label: "Title 1",
                            placeholder: "Enter the Title",
                        },
                        {
                            key: "Title2",
                            label: "Title 2",
                            placeholder: "Enter the Title",
                        },
                    ]}
                    defaultTexts={
                        templateDefaultValue.Application.LaindingPage.Default
                            .Loyalty
                    }
                    sectionTitle="Title"
                />
            </section>
        </div>
    );
}
